import React from 'react'
import PeopleCard from '../PeopleProfileCard';
import img1 from "../../../Images/Ghufran.jpeg"

const createElements = () => {
  const elements = [];
  const PeopleImagesUrl = [img1];
  const PeopleName = ['Md Ghufran Jamali'];
  const PeopleEmailId = ['ghufranjamali35@gmail.com',];
  const PeopleDescription = [
  `B.Tech - Mechanical Engineering, 2018
   M.Tech. - Thermal Engineering, 2024`];
  const Link = [
    "link",
    "",
    "",
    "",
    "",
  ];


  for (var i=0;i<PeopleName.length;i++){
      elements.push(<PeopleCard key = {i} peopleImagesUrl = {PeopleImagesUrl[i]} peopleName = {PeopleName[i]} peopleEmailId = {PeopleEmailId[i]} peopleDescription = {PeopleDescription[i]} link={Link[i]}/>)
  }
  return elements
}


const ResearchAssociate = () => {
  return (
    <div className="album py-2">
      <div className="row">
      {createElements()}
    </div>
  </div>
  )
}

export default ResearchAssociate